<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <Component
    v-bind="{ ...$attrs, ...props }"
    :is="buttonComponent"
    class="ui-button"
    @click="onClick($event)"
    @mouseleave="emit('mouseleave')"
    @mouseenter="emit('mouseenter')"
  >
    <slot />
  </Component>
</template>

<script lang="ts" setup>
import {
  primaryButtonColors,
  secondaryButtonColors,
  thirdButtonColors,
  defaultButtonColors,
} from './buttonColors'

interface UiButtonProps {
  color?:
    | keyof typeof primaryButtonColors
    | keyof typeof secondaryButtonColors
    | keyof typeof defaultButtonColors
    | keyof typeof thirdButtonColors
  primary?: boolean
  secondary?: boolean
  third?: boolean
  underline?: boolean
  icon?: boolean
  tag?: any
  rounded?: boolean
  loading?: boolean
}

const props = withDefaults(defineProps<UiButtonProps>(), {
  tag: 'button',
  color: 'primary',
})

const emit = defineEmits<{
  (e: 'click', event: Event): void
  (e: 'mouseleave'): void
  (e: 'mouseenter'): void
}>()

const buttonComponent = computed(() => {
  if (props.primary) return resolveComponent('UiButtonPrimary')
  if (props.secondary) return resolveComponent('UiButtonSecondary')
  if (props.underline) return resolveComponent('UiButtonUnderline')
  if (props.icon) return resolveComponent('UiButtonIcon')
  if (props.third) return resolveComponent('UiButtonThird')

  return resolveComponent('UiButtonDefault')
})

const onClick = (event: Event) => {
  if (props.loading) event.preventDefault()

  !props.loading && emit('click', event)
}
</script>
